/**
 * Returns the storage account uri corresponds to the given region.
 * @param region The region of the resource.
 * @param isProduction Indicates whether the portal is in production environment or not.
 * @returns String of the corresponding uri.
 */
export const getBlobUriByRegion = (region: string, isProduction: boolean): string => {
    const upperCasedRegion = region.toUpperCase();
    let storageAccountName = '';

    if (!isProduction) {
        storageAccountName = 'qnamakerppestorage';
    } else if (upperCasedRegion === 'CHINAEAST2' || upperCasedRegion === 'CHINANORTH2' || upperCasedRegion === 'CHINANORTH3') {
        return 'https://qsche2mc.blob.core.chinacloudapi.cn/portal-files';
    } else if (upperCasedRegion === 'USGOVARIZONA') {
        return 'https://qsusgaff.blob.core.usgovcloudapi.net/portal-files';
    } else if (upperCasedRegion === 'USGOVVIRGINIA') {
        return 'https://qnamakerstore.blob.core.usgovcloudapi.net/portal-files';
    } else {
        switch (upperCasedRegion) {
            case 'AUSTRALIAEAST':
                storageAccountName = 'qnamakerstoreaueast';
                break;
            case 'BRAZILSOUTH':
                storageAccountName = 'qsbrsame';
                break;
            case 'CANADACENTRAL':
                storageAccountName = 'qscacame';
                break;
            case 'CENTRALINDIA':
                storageAccountName = 'qsincame';
                break;
            case 'CENTRALUS':
                storageAccountName = 'qsuscame';
                break;
            case 'CENTRALUSEUAP':
                storageAccountName = 'qsuscxame';
                break;
            case 'EASTASIA':
                storageAccountName = 'qsaeame';
                break;
            case 'EASTUS':
                storageAccountName = 'qsuseame';
                break;
            case 'EASTUS2':
                storageAccountName = 'qsuse2ame';
                break;
            case 'EASTUS2EUAP':
                storageAccountName = 'qsuse2xame';
                break;
            case 'FRANCECENTRAL':
                storageAccountName = 'qsfcame';
                break;
            case 'GERMANYWESTCENTRAL':
                storageAccountName = 'qsgwcame';
                break;
            case 'JAPANEAST':
                storageAccountName = 'qsjpeame';
                break;
            case 'JAPANWEST':
                storageAccountName = 'qsjpwame';
                break;
            case 'JIOINDIAWEST':
                storageAccountName = 'qsjinwame';
                break;
            case 'KOREACENTRAL':
                storageAccountName = 'qskcame';
                break;
            case 'NORTHCENTRALUS':
                storageAccountName = 'qsusncame';
                break;
            case 'NORTHEUROPE':
                storageAccountName = 'qnamakerstorenortheurope';
                break;
            case 'NORWAYEAST':
                storageAccountName = 'qsnoeame';
                break;
            case 'QATARCENTRAL':
                storageAccountName = 'qsqacame';
                break;
            case 'SOUTHAFRICANORTH':
                storageAccountName = 'qssaname';
                break;
            case 'SOUTHCENTRALUS':
                storageAccountName = 'qnamakerstoresouthcentus';
                break;
            case 'SOUTHEASTASIA':
                storageAccountName = 'qsaseame';
                break;
            case 'SWEDENCENTRAL':
                storageAccountName = 'qssecame';
                break;
            case 'SWITZERLANDNORTH':
                storageAccountName = 'qsswname';
                break;
            case 'SWITZERLANDWEST':
                storageAccountName = 'qsswwame';
                break;
            case 'UAENORTH':
                storageAccountName = 'qsuaename';
                break;
            case 'UKSOUTH':
                storageAccountName = 'qsuksame';
                break;
            case 'WESTCENTRALUS':
                storageAccountName = 'qsuswcame';
                break;
            case 'WESTEUROPE':
                storageAccountName = 'qsweuame';
                break;
            case 'WESTUS':
                storageAccountName = 'qnamakerstore';
                break;
            case 'WESTUS2':
                storageAccountName = 'qsusw2ame';
                break;
            case 'WESTUS3':
                storageAccountName = 'qsusw3ame';
                break;
            default:
                throw new Error(`Internal Error: Invalid region ${region} for QnA Maker blob storage account name.`);
        }
    }

    return `https://${storageAccountName}.blob.core.windows.net/portal-files`;
};
